import { InterstateDealSummarySections, useDealSummary } from '@makemydeal/dr-dash-components';
import { List } from '@interstate/components/List';

const Finance: React.FC = () => {
    const { showDetailedView } = useDealSummary();

    return (
        <>
            <List data-testid="finance-deal-summary">
                <InterstateDealSummarySections.InterstateMSRP />
                <InterstateDealSummarySections.InterstateDiscount />
                <InterstateDealSummarySections.InterstateDealerDiscounts />
                <InterstateDealSummarySections.InterstateSellingPrice />
                <InterstateDealSummarySections.InterstateAddons />
                <InterstateDealSummarySections.InterstateTotalTax />
                <InterstateDealSummarySections.InterstateNetSellingPrice />
                <InterstateDealSummarySections.InterstateNetTrade />
                <InterstateDealSummarySections.InterstateRebates />
                <InterstateDealSummarySections.InterstateCashDown />
                <InterstateDealSummarySections.InterstateAmountFinanced />
                <InterstateDealSummarySections.InterstateTotalOfPayments />
                <InterstateDealSummarySections.InterstatePriorBalance />
                <InterstateDealSummarySections.InterstateTrades />
                {showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
            </List>
            {!showDetailedView && <InterstateDealSummarySections.InterstateDealPulse />}
        </>
    );
};

export default Finance;
